import { render, staticRenderFns } from "./WealthProductWithdrawReview.vue?vue&type=template&id=c47ca1f8&scoped=true"
import script from "./WealthProductWithdrawReview.vue?vue&type=script&lang=ts"
export * from "./WealthProductWithdrawReview.vue?vue&type=script&lang=ts"
import style0 from "./WealthProductWithdrawReview.vue?vue&type=style&index=0&id=c47ca1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ca1f8",
  null
  
)

export default component.exports